import { GlobalVariables } from '../pdf/GlobalVariables';
import { devError, devLog, devWarning } from './developmentUtils';

/** 
 * Only log the message, if it's a new one (and wasn't logged before yet).
 */
export function devLogOnce(message: string): void {
  if (!GlobalVariables.reportedDevLogs.includes(message)) {
    GlobalVariables.reportedDevLogs.push(message);
    devLog(message);
  }
}

/** 
 * Only log the warning, if it's a new one (and wasn't logged before yet).
 */
export function devWarningOnce(message: string) {
  if (!GlobalVariables.reportedDevWarnings.includes(message)) {
    GlobalVariables.reportedDevWarnings.push(message);
    devWarning(message);
  }
}

/** 
 * Only log the error, if it's a new one (and wasn't logged before yet).
 */
export function devErrorOnce(error: Error) {
  if (!GlobalVariables.reportedDevErrors.includes(error.message)) {
    GlobalVariables.reportedDevErrors.push(error.message);
    devError(error);
  }
}
